import { useQuery } from 'react-query';
import api from 'services';
import type { ApiError } from 'services/api.errors';
import type { IraUsersResponse } from 'services/requests';
import { DefaultOrder } from 'types/order';
import { useQueryOrder, useQueryPage, useQueryParams } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import { Parameters } from 'constants/queryParameters';
import type { AxiosError } from 'axios';

export const useGetIraUsers = () => {
  const employerId = useQueryParams(Parameters.employerId);
  const { size, page } = useQueryPage();
  const [order, setOrder] = useQueryOrder();

  const defaultOrder: DefaultOrder<'fullName'> = ['fullName', 'asc'];

  const queryOrder = !order
    ? { orderBy: defaultOrder[0] }
    : order[1] === 'asc'
    ? { orderBy: order[0] }
    : { orderByDesc: order?.[0] ?? '' };

  const params = {
    page,
    size,
    ...queryOrder,
  };

  const queryKey = [QueryKeys.iraUsers, employerId, size, page, order ?? defaultOrder];

  const queryFn = async () => {
    const { data } = await api.getIraUsers(employerId, params);
    return data;
  };

  return useQuery<IraUsersResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    onSuccess: () => {
      if (!order) {
        setOrder(defaultOrder, { replace: true });
      }
    },
  });
};
